module.exports = __webpack_public_path__ + "static/img/1_6_2.a85fd68c.jpg";